import { render, staticRenderFns } from "./view02.vue?vue&type=template&id=f0001a9a&"
import script from "./view02.vue?vue&type=script&lang=js&"
export * from "./view02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports